import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02fc5016&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=02fc5016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc5016",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiMenu: require('/var/www/html/intelli.com.br/components/base/ui/Menu.vue').default,BaseUiGallery: require('/var/www/html/intelli.com.br/components/base/ui/Gallery.vue').default,BaseUiCardApplications: require('/var/www/html/intelli.com.br/components/base/ui/CardApplications.vue').default,BaseUiSlideIt: require('/var/www/html/intelli.com.br/components/base/ui/SlideIt.vue').default})
